import { render, staticRenderFns } from "./Elevation.vue?vue&type=template&id=97886e0c&"
import script from "./Elevation.vue?vue&type=script&lang=js&"
export * from "./Elevation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports